import React, { useState } from "react";
import { Button, Dialog, Text } from "@ui5/webcomponents-react";
import * as XLSX from "xlsx";

const ImportBultos = ({ onDataLoad, cantidadBultos, totalPesoBulto }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [pesoTotal, setPesoTotal] = useState(0);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Mapeo de las columnas
  const columnMapping = {
    Bulto: "bultoNumber",
    Peso: "peso",
    Altura: "altura",
    Longitud: "largo",
    Ancho: "ancho",
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (
      file &&
      (file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel")
    ) {
      setSelectedFile(file);
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        const mappedData = jsonData.map((row) => {
          const mappedRow = {};
          for (const [key, value] of Object.entries(row)) {
            if (columnMapping[key]) {
              mappedRow[columnMapping[key]] =
                columnMapping[key] === "bultoNumber" ? String(value) : value;
            }
          }
          return mappedRow;
        });

        console.log("Datos mapeados:", mappedData);

        // Validación: Cantidad de filas vs cantidadBultos
        if (mappedData.length !== cantidadBultos) {
          setErrorMessage(
            `La cantidad de filas (${mappedData.length}) no coincide con la cantidad de bultos esperados (${cantidadBultos}).`
          );
          setIsDialogOpen(true);
          return; // Salir si hay un error de validación
        }

        // Calcular peso total
        const totalPeso = mappedData.reduce((acc, bulto) => {
          const peso = parseFloat(bulto.peso) || 0; // Convertir a número o usar 0 si es NaN
          return acc + peso;
        }, 0);

        console.log("Peso total calculado:", totalPeso);

        // Validación de peso total
        if (totalPeso !== totalPesoBulto) {
          setErrorMessage(
            `El peso total calculado (${totalPeso}) no coincide con totalPesoBulto (${totalPesoBulto}).`
          );
          setIsDialogOpen(true);
        } else {
          console.log("Peso total coincide con totalPesoBulto.");
        }

        setPesoTotal(totalPeso);

        if (onDataLoad) {
          onDataLoad(mappedData);
        } else {
          console.error("onDataLoad no está definido.");
        }
      };

      reader.readAsArrayBuffer(file);
    } else {
      setErrorMessage("Por favor selecciona un archivo Excel válido.");
      setIsDialogOpen(true);
    }
  };

  return (
    <div>
      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={handleFileChange}
        style={{ display: "none" }}
        id="import-bultos-file-upload"
      />
      <label htmlFor="import-bultos-file-upload">
        <Button
          icon="upload"
          onClick={() => document.getElementById("import-bultos-file-upload").click()}
          style={{ backgroundColor: 'green', color: 'white' }}
        >
          Importar
        </Button>
      </label>

      <Dialog
        open={isDialogOpen}
        onAfterClose={() => setIsDialogOpen(false)}
        headerText="Error de Validación"
      >
        <Text>{errorMessage}</Text>
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0.5rem' }}>

        <Button  design="Transparent" style={{ backgroundColor: 'red', color: 'white' }} onClick={() => setIsDialogOpen(false)}>Cerrar</Button>
        
        </div>
      </Dialog>
    </div>
  );
};

export default ImportBultos;